import { Btn, FeatherIcons, H4, Image, LI, P, UL } from "../../../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import { profilesMessage } from "../../../../Data/Layout/Header";
import { useAuth } from "../../../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import CommonModal from "../../../../Component/Ui-Kits/Modal/Common/CommonModal";
import { dynamicImage } from "../../../../Service";

const ProfileBox = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [centred, setCentered] = useState(false);

  const centeredToggle = () => setCentered(!centred);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const OnLogoutConfirm = () => {
    centeredToggle();
    handleLogout();
  };

  // Mapear nombres a claves de traducción
  const getTranslationKey = (name: string) => {
    const translationMap: { [key: string]: string } = {
      "My Profile": "Mi Perfil",
      "Settings": "Configuración",
    };
    return translationMap[name] || name;
  };

  return (
    <UL className="profile-dropdown onhover-show-div">
      {profilesMessage.map((data, index) => (
        <LI key={index}>
          <Link to={data.link}>
            <FeatherIcons iconName={data.icon} />
            <span>{t(getTranslationKey(data.name))} </span>
          </Link>
        </LI>
      ))}
      <LI>
        <Btn 
          size="sm" 
          outline 
          color="primary" 
          className="btn-pill" 
          onClick={centeredToggle}
        >
          {t("Cerrar Sesión")}
        </Btn>
      </LI>
      <CommonModal centered isOpen={centred} toggle={centeredToggle}>
        <div className="modal-toggle-wrapper">
          <UL className="modal-img">
            <LI className="text-center">
              <Image src={dynamicImage(`gif/danger.gif`)} alt="error" />
            </LI>
          </UL>
          <H4 className="text-center pb-2">{t("¿Desea cerrar sesión?")}</H4>
          <P className="text-center">
            {t("Esta acción cerrará tu sesión actual y deberás iniciar sesión nuevamente para acceder al sistema.")}
          </P>
          <div className="d-flex justify-content-center gap-2 mt-3">
            <Btn color="secondary" onClick={centeredToggle}>
              {t("Cancelar")}
            </Btn>
            <Btn color="primary" onClick={OnLogoutConfirm}>
              {t("Confirmar")}
            </Btn>
          </div>
        </div>
      </CommonModal>
    </UL>
  );
};

export default ProfileBox;
